import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { createShowroomStore, showroomStoreKey } from './store/showroom'
import './styles.css'

const app = createApp(App)
app.provide(showroomStoreKey, createShowroomStore())
app.use(router)
app.mount('#app')

